// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__1utjE","container":"styles_container___YiqN","title":"styles_title__1KcaC","wrapper":"styles_wrapper__3VtVc","answer":"styles_answer__EwCJP"};